import { createSlice,PayloadAction } from "@reduxjs/toolkit";
import { LAYOUTCONFIG } from "config/layoutConfig";
interface LayoutState {
  foldedOpen: boolean;
  themeMode: string;
  returnUserObj:  any;
}

const initialState: LayoutState = {
  foldedOpen: LAYOUTCONFIG.defaultSidebarCollapsed,
  themeMode: LAYOUTCONFIG.themeMode,
  returnUserObj: {},
};

const navbarSlice = createSlice({
  name: "navbar",
  initialState,
  reducers: {
    navbarToggleFolded: (state) => {
      console.log("navbarToggleFolded");
      state.foldedOpen = !state.foldedOpen;
    },
    navbarOpenFolded: (state) => {
      state.foldedOpen = true;
    },
    navbarCloseFolded: (state) => {
      state.foldedOpen = false;
    },
    themeChange: (state) => {
      console.log(state.themeMode);
      state.themeMode = state.themeMode == "light" ? "dark" : "light";
    },
    dispatchReturnUserObj: (state, action: PayloadAction<string>) => {
      state.returnUserObj = action.payload ? action.payload : "sri2345";
    },
    resetLayout: () => initialState,
  },
});

export const {
  navbarToggleFolded,
  navbarOpenFolded,
  navbarCloseFolded,
  themeChange,
  dispatchReturnUserObj,
   resetLayout
} = navbarSlice.actions;

export default navbarSlice.reducer;
